import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    class: _normalizeClass(["block border-2 border-nucleus-primaryBlue text-nucleus-text hover:bg-nucleus-primaryMouseOver hover:text-white p-3 text-lg text-center shadow-md rounded-full transition w-full", { 'border-nucleus-error hover:bg-nucleus-error': _ctx.error }])
  }, _toDisplayString(_ctx.name), 11, _hoisted_1))
}